import { MenuItemType } from './menu-item-type.enum';
import './style.scss';
import { Link } from 'react-router-dom';

export interface MenuItem {
  type: MenuItemType;
  label: string;
  onClick?: () => void;
  link?: string;
}

function ListItemDropDownMenu({ menuItems }: { menuItems: MenuItem[] }) {
  return (
    <>
      <button type="button" className="dropdown-toggle btn--menu-dots" aria-label="Öppna meny" data-bs-toggle="dropdown" aria-expanded="false"></button>
      <ul className="dropdown-menu">
        {menuItems.map((item) => (
          <li key={item.label} className="dropdown-menu-item">
            {item.type === MenuItemType.Delete ? (
              <button type="button" className="dropdown-item dropdown-item__delete" onClick={() => item.onClick?.()}>
                {item.label}
              </button>
            ) : (
              <Link className="dropdown-item dropdown-item__edit" to={item.link || '#'}>
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </>
  );
}

export default ListItemDropDownMenu;
